import LoadingSkeleton from "./LoadingSkeleton";

export default LoadingSkeleton;
